import type { DateRange, PoiFilterValue } from '../types';
import { OptionId, type OptionId$options } from '$houdini';

export function isValueDateRange(values: PoiFilterValue): values is DateRange {
	return typeof values === 'object' && 'startDate' in values && 'endDate' in values;
}

export function isAccommodationPrice(values: PoiFilterValue): values is number[] {
	return Array.isArray(values) && values.length === 2;
}

export function isAccommodationOptions(values: PoiFilterValue): values is OptionId$options[] {
	const options = Object.values(OptionId);
	return (
		Array.isArray(values)
		&& values.every(
			value => value !== undefined && typeof value !== 'number' && options.includes(value),
		)
	);
}

export function getAccommodationFilterValue(filter: any) {
	return isAccommodationOptions(filter) ? filter.join('|') : undefined;
}
